import { Center, Spinner } from '@chakra-ui/react';

function CenterSpinner() {
  return (
    <Center width="full" height="full" flexGrow={1}>
      <Spinner color="brand.purple" size="xl" mb="50px" />
    </Center>
  );
}

export default CenterSpinner;
